import React, {useContext} from "react";
import Headroom from "react-headroom";
import {Link, useLocation} from "react-router-dom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  openSource,
  blogSection,
  talkSection,
  achievementSection,
  privateSpaceSection
} from "../../portfolio";

function Header() {
  const {isDark} = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewOpenSource = openSource.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewBlog = blogSection.display;
  const viewTalks = talkSection.display;
  const viewPrivateSpace = privateSpaceSection.display;
  // On /private the in-page anchors below point at sections that aren't
  // rendered, so that page gets a trimmed-down menu instead.
  const isPrivatePage = useLocation().pathname === "/private";

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <Link to="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </Link>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {isPrivatePage && (
            <li>
              <Link to="/">Back to portfolio</Link>
            </li>
          )}
          {!isPrivatePage && viewSkills && (
            <li>
              <a href="#skills">Skills</a>
            </li>
          )}
          {!isPrivatePage && viewExperience && (
            <li>
              <a href="#experience">Work Experiences</a>
            </li>
          )}
          {!isPrivatePage && viewOpenSource && (
            <li>
              <a href="#opensource">Open Source</a>
            </li>
          )}
          {!isPrivatePage && viewAchievement && (
            <li>
              <a href="#achievements">Achievements</a>
            </li>
          )}
          {!isPrivatePage && viewBlog && (
            <li>
              <a href="#blogs">Blogs</a>
            </li>
          )}
          {!isPrivatePage && viewTalks && (
            <li>
              <a href="#talks">Talks</a>
            </li>
          )}
          {!isPrivatePage && (
            <li>
              <a href="#contact">Contact Me</a>
            </li>
          )}
          {!isPrivatePage && viewPrivateSpace && (
            <li>
              <Link to="/private">{privateSpaceSection.navLabel}</Link>
            </li>
          )}
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
